const product = state => state.product;
const products = state => state.products;
const product_types = state => state.product_types;
const subscription = state => state.subscription;
const current_subscription = state => state.current_subscription;
const other_subscription = state => state.other_subscription;
const previous_item_subscriptions = state => state.previous_item_subscriptions;
const previous_any_item_subscriptions = state => state.previous_any_item_subscriptions;
const subscriptions = state => state.subscriptions;
const chosen_item = state => state.chosen_item;
const item_transaction_history = state => state.item_transaction_history;
const receipt_item_info = state => state.receipt_item_info;
const receipt_info = state => state.receipt_info;
const receipt_status = state => state.receipt_status;
const active_free_month = state => state.active_free_month;

export {
    product,
    products,
    product_types,
    subscription,
    current_subscription,
    other_subscription,
    previous_item_subscriptions,
    previous_any_item_subscriptions,
    subscriptions,
    chosen_item,
    item_transaction_history,
    receipt_item_info,
    receipt_info,
    receipt_status,
    active_free_month
}
